// TODO: валидация схемы данных отключена до предоставления полного варианта ответа для генерации схемы

// import { ajvValidator } from './ajv_validator';

export const validateEgdSchema = json => {
  // const validate = ajvValidator.compile(egdJsonSchema);
  return true; // validate(json);
};

// const egdJsonSchema = {
//   required: ['blockchainUid', 'regNo'],
//   type: 'object',
//   properties: {
//     regNo: {
//       type: 'string',
//     },
//     blockchainUid: {
//       type: 'string',
//     },
//     data: {
//       type: 'object',
//       properties: {
//         dezname: {
//           type: 'string',
//         },
//         okrug: {
//           type: 'string',
//         },
//         service_company: {
//           type: 'string',
//         },
//         adr_tel_company: {
//           type: 'string',
//         },
//         street: {
//           type: 'string',
//         },
//         house: {
//           type: 'string',
//         },
//         korp: {
//           type: 'string',
//         },
//         stroen: {
//           type: 'string',
//         },
//         flat: {
//           type: 'string',
//         },
//         pass: {
//           type: 'null',
//         },
//         change_reason: {
//           type: 'null',
//         },
//         oks: {
//           type: 'string',
//         },
//         oks_decl: {
//           type: 'string',
//         },
//         owners: {
//           type: 'string',
//         },
//         croom_flat: {
//           type: 'string',
//         },
//         floor: {
//           type: 'string',
//         },
//         cfloor: {
//           type: 'string',
//         },
//         house_year: {
//           type: 'string',
//         },
//         lift: {
//           type: 'string',
//         },
//         centr_otopl: {
//           type: 'string',
//         },
//         cw: {
//           type: 'string',
//         },
//         hw: {
//           type: 'string',
//         },
//         schema_hw: {
//           type: 'string',
//         },
//         electr: {
//           type: 'string',
//         },
//         vanna: {
//           type: 'string',
//         },
//         gas: {
//           type: 'string',
//         },
//         kanal: {
//           type: 'string',
//         },
//         counter_type: {
//           type: 'string',
//         },
//         s_All: {
//           type: 'string',
//         },
//         s_Gil: {
//           type: 'string',
//         },
//         s_kitchen: {
//           type: 'string',
//         },
//         s_AllLet: {
//           type: 'string',
//         },
//         s_Priv: {
//           type: 'string',
//         },
//         s_Let: {
//           type: 'string',
//         },
//         cfls: {
//           type: 'string',
//         },
//         material_sten: {
//           type: 'string',
//         },
//         san_type: {
//           type: 'string',
//         },
//         seria: {
//           type: 'string',
//         },
//         period: {
//           type: 'string',
//         },
//         user_name: {
//           type: 'string',
//         },
//         currdate: {
//           type: 'string',
//         },
//         fd: {
//           type: 'string',
//         },
//         firm_name: {
//           type: 'string',
//         },
//         fls_all_sqr: {
//           type: 'string',
//         },
//         fls_gil_sqr: {
//           type: 'string',
//         },
//         curr_doc_zayavitel: {
//           type: 'string',
//         },
//         curr_without_doc: {
//           type: 'string',
//         },
//         dopAttr: {
//           type: 'string',
//         },
//         flsId: {
//           type: 'string',
//         },
//         zayav_man: {
//           type: 'string',
//         },
//         zayav_man_decl: {
//           type: 'string',
//         },
//         zayav_own_noreg: {
//           type: 'string',
//         },
//         flat_type: {
//           type: 'string',
//         },
//         room_Count: {
//           type: 'string',
//         },
//         house_prinadl: {
//           type: 'string',
//         },
//         is_subs: {
//           type: 'string',
//         },
//         is_dolg: {
//           type: 'string',
//         },
//         is_sobstv: {
//           type: 'integer',
//         },
//       },
//     },
//     rooms: {
//       type: 'array',
//       items: [
//         {
//           type: 'object',
//           properties: {
//             nom: {
//               type: 'string',
//             },
//             flsid: {
//               type: 'string',
//             },
//             room_plan: {
//               type: 'string',
//             },
//             s_room: {
//               type: 'string',
//             },
//             s_room_all: {
//               type: 'string',
//             },
//             oks: {
//               type: 'string',
//             },
//           },
//         },
//         {
//           type: 'object',
//           properties: {
//             nom: {
//               type: 'string',
//             },
//             flsid: {
//               type: 'string',
//             },
//             room_plan: {
//               type: 'null',
//             },
//             s_room: {
//               type: 'string',
//             },
//             s_room_all: {
//               type: 'string',
//             },
//             oks: {
//               type: 'string',
//             },
//           },
//         },
//       ],
//     },
//     people: {
//       type: 'array',
//       items: [
//         {
//           type: 'object',
//           properties: {
//             fio: {
//               type: 'string',
//             },
//             birth_date: {
//               type: 'string',
//             },
//             birth_location: {
//               type: 'null',
//             },
//             rel_type: {
//               type: 'string',
//             },
//             passport: {
//               type: 'null',
//             },
//             reg_from: {
//               type: 'null',
//             },
//             reg_type: {
//               type: 'string',
//             },
//             reg_date: {
//               type: 'null',
//             },
//           },
//         },
//         {
//           type: 'object',
//           properties: {
//             fio: {
//               type: 'string',
//             },
//             birth_date: {
//               type: 'string',
//             },
//             birth_location: {
//               type: 'string',
//             },
//             rel_type: {
//               type: 'string',
//             },
//             passport: {
//               type: 'string',
//             },
//             reg_from: {
//               type: 'string',
//             },
//             reg_type: {
//               type: 'string',
//             },
//             reg_date: {
//               type: 'string',
//             },
//           },
//         },
//         {
//           type: 'object',
//           properties: {
//             fio: {
//               type: 'string',
//             },
//             birth_date: {
//               type: 'string',
//             },
//             birth_location: {
//               type: 'string',
//             },
//             rel_type: {
//               type: 'string',
//             },
//             passport: {
//               type: 'string',
//             },
//             reg_from: {
//               type: 'string',
//             },
//             reg_type: {
//               type: 'string',
//             },
//             reg_date: {
//               type: 'string',
//             },
//           },
//         },
//         {
//           type: 'object',
//           properties: {
//             fio: {
//               type: 'string',
//             },
//             birth_date: {
//               type: 'string',
//             },
//             birth_location: {
//               type: 'null',
//             },
//             rel_type: {
//               type: 'string',
//             },
//             passport: {
//               type: 'null',
//             },
//             reg_from: {
//               type: 'null',
//             },
//             reg_type: {
//               type: 'string',
//             },
//             reg_date: {
//               type: 'null',
//             },
//           },
//         },
//       ],
//     },
//     fls_man: {
//       type: 'array',
//       items: [
//         {
//           type: 'object',
//           properties: {
//             fls_id: {
//               type: 'string',
//             },
//             cman_reg: {
//               type: 'string',
//             },
//           },
//         },
//       ],
//     },
//     docs: {
//       type: 'object',
//       properties: {
//         doc: {
//           type: 'object',
//           properties: {
//             name: {
//               type: 'string',
//             },
//             who: {
//               type: 'string',
//             },
//           },
//         },
//       },
//     },
//     part_type_list: {
//       type: 'array',
//       items: [
//         {
//           type: 'string',
//         },
//       ],
//     },
//     owners: {
//       type: 'array',
//       items: [
//         {
//           type: 'object',
//           properties: {
//             fio: {
//               type: 'string',
//             },
//             own_perc: {
//               type: 'string',
//             },
//             one_part: {
//               type: 'string',
//             },
//           },
//         },
//         {
//           type: 'object',
//           properties: {
//             fio: {
//               type: 'string',
//             },
//             own_perc: {
//               type: 'string',
//             },
//             one_part: {
//               type: 'string',
//             },
//           },
//         },
//       ],
//     },
//     pref_list: {
//       type: 'array',
//       items: [
//         {
//           type: 'object',
//           properties: {
//             pref_owner_fio: {
//               type: 'string',
//             },
//             pref_id: {
//               type: 'string',
//             },
//           },
//         },
//         {
//           type: 'object',
//           properties: {
//             pref_owner_fio: {
//               type: 'string',
//             },
//             pref_id: {
//               type: 'string',
//             },
//           },
//         },
//       ],
//     },
//     dolg_per: {
//       type: 'object',
//       properties: {
//         periods: {
//           type: 'null',
//         },
//         servs: {
//           type: 'object',
//           properties: {
//             serv: {
//               type: 'object',
//               properties: {
//                 period: {
//                   type: 'object',
//                   properties: {
//                     dolg: {
//                       type: 'string',
//                     },
//                     period: {
//                       type: 'string',
//                     },
//                   },
//                 },
//               },
//             },
//           },
//         },
//       },
//     },
//   },
// };
